export const PRIORITY_OPTIONS = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' }
];

// For display purposes - 5 fire is highest priority
export const MAX_PRIORITY = 5;
export const MIN_PRIORITY = 1;
export const DEFAULT_PRIORITY = 1;
